import { lexonHttp } from "@/plugins/axios/lexonHttp";

export class SelectedRegisterService {
  constructor() {}

  getData(url: string) {
    return lexonHttp.get(url)
  }
}
